const scroll = {
  namespaced: true,
  state: {
    item: false,
  },
  mutations: {
    setScroll(state, payload) {
      state.item = payload;
    },
  },
  actions: {},
  getters: {},
};

export default scroll;
